// =============================================================================
// Invite-link entry: /i/:slug
// =============================================================================
// Records the click, stashes the slug into localStorage + a cookie (3-layer
// capture per architecture doc §6/F4), then redirects to /welcome (the story
// video — the funnel starts there). Auth + signup happen after the video; the
// signup page reads the slug from localStorage and sends it as referrerSlug.
// =============================================================================

import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { api } from "@/lib/api"
import { persistRef } from "@/lib/referrer"

export function InvitePage() {
  const { slug } = useParams<{ slug: string }>()
  const navigate = useNavigate()

  useEffect(() => {
    if (!slug) {
      navigate("/", { replace: true })
      return
    }
    // Capture the slug in localStorage + a 30-day cookie (same-browser layers);
    // the `?ref=` we forward below is the primary carrier through the funnel.
    persistRef(slug)
    // Record the click — non-blocking.
    api.post("/api/click", { slug }).catch(() => {})
    // Redirect to the story video — the funnel now starts there.
    navigate(`/welcome?ref=${encodeURIComponent(slug)}`, { replace: true })
  }, [slug, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center text-[#6B7280] text-sm">
      מעביר אותך…
    </div>
  )
}
